<div class="empty-list">
    <img src="assets/images/empty.png" alt="">
    <p>
        {{emptyTitle}}
    </p>
</div>
